import React, { useEffect } from "react";
import Tour from "reactour";

const ReusableTour = ({ steps, isOpen, onRequestClose, onSkip, accentColor = "#2563eb", rounded = 12 }) => {
  const handleSkip = () => {
    // Clear all tour permissions when skip is clicked
    const permissions = JSON.parse(localStorage.getItem("tourPermissions"));
    if (permissions) {
      permissions.showStudentLookupTour = false;
      permissions.showStaffReportTour = false;
      permissions.showAllStudentsTour = false;
      permissions.showStaffDashboardTabsTour = false;
      permissions.showBatchAnalysisTour = false;
      localStorage.setItem("tourPermissions", JSON.stringify(permissions));
    }
    // Call the component's close handler
    if (onSkip) onSkip();
    // Force close the tour
    if (onRequestClose) onRequestClose(true);
  };

  // Robust X-button detection: reactour's onRequestClose does not pass the click event.
  // We attach a capturing listener while the tour is open to catch clicks on the X.
  useEffect(() => {
    if (!isOpen) return;

    const handleDocumentClick = (e) => {
      const isXButton = e.target && (
        e.target.closest('[data-tour-elem="close"]') ||
        e.target.closest('button[aria-label="Close"]') ||
        e.target.closest('[aria-label="Close"]') ||
        e.target.closest('.reactour__close')
      );
      if (isXButton) {
        // Prevent Reactour from handling this as a generic close
        try {
          e.stopPropagation();
          e.preventDefault();
        } catch {}
        // Disable all tours when X is clicked
        const permissions = JSON.parse(localStorage.getItem("tourPermissions"));
        if (permissions) {
          permissions.showStudentLookupTour = false;
          permissions.showStaffReportTour = false;
          permissions.showAllStudentsTour = false;
          permissions.showStaffDashboardTabsTour = false;
          permissions.showBatchAnalysisTour = false;
          localStorage.setItem("tourPermissions", JSON.stringify(permissions));
        }
        if (onRequestClose) onRequestClose(true);
      }
    };

    document.addEventListener('click', handleDocumentClick, true);
    return () => document.removeEventListener('click', handleDocumentClick, true);
  }, [isOpen, onRequestClose]);

  return (
    <Tour
      steps={steps}
      isOpen={isOpen}
      // Reactour calls this when closing via mask or finishing the tour.
      // Treat non-X closures (e.g., "Got it!") as current-tour only.
      onRequestClose={() => {
        if (onRequestClose) onRequestClose(false);
      }}
      accentColor={accentColor}
      rounded={rounded}
      showNumber={false}
      showNavigation={true}
      showButtons={true}
      showCloseButton={true}
      lastStepNextButton={
        <button
          style={{
            backgroundColor: "#0e3d5d",
            color: "white",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Got it!
        </button>
      }
      nextButton={
        <button
          style={{
            backgroundColor: "#0e3d5d",
            color: "white",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Next →
        </button>
      }
      prevButton={
        <button
          style={{
            backgroundColor: "transparent",
            color: "#6b7280",
            padding: "8px 20px",
            borderRadius: "8px",
            border: "1px solid #d1d5db",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          ← Back
        </button>
      }
      closeWithMask={false}
      disableInteraction={true}
    />
  );
};

export default ReusableTour;
